import { types, actions } from './requests'
export const UPDATECOST_TYPES = {
    ...types('UPDATECOST'),
}
export const UPDATECOST_ACTIONS = {
    ...actions('UPDATECOST'),
}
